import React from 'react'
import {
  Form,
  Button,
  TextInput
} from 'carbon-components-react'

import Validator from '../utils/Validator'
import LoginValidator from '../validators/Login'
import PasswordInput from './PasswordInput'

const initialState = {
  email: '',
  password: '',

  initialErrors: {},
  errors: {}
}

export default class extends Validator {
  state = { ...initialState }

  constructor(props) {
    super(props)

    this.validator = LoginValidator
  }

  submit() {
    this.props.onSubmit(this.state)
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className='formRow'>
          <TextInput id='email'
            name='email'
            labelText='Email *'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={this.state.email || ''}
            invalid={this.state.errors.email || this.props.errors ? true : false}
            invalidText={this.state.errors.email || (this.props.errors ? 'Invalid email/password' : '')} />
        </div>
        <div className='formRow mb-0'>
          <PasswordInput
            id='password'
            name='password'
            labelText='Password *'
            type='password'
            onChange={this.handleChange}
            onBlur={this.handleDirty}
            value={this.state.password || ''}
            invalid={this.state.errors.password || this.props.errors ? true : false}
            invalidText={this.state.errors.password || ''} />
        </div>
        <div className='formRow'>
          <Button type='submit' className='loginSubmit'>
            { this.props.loading ? 'Logging In...' : 'Login' }
          </Button>
        </div>
      </Form>
    )
  }
}
